import'./common/global.mjs';
import { ujsxFor } from'./bind.mjs';
import { isUJSXObject, createUJSXObject } from'./common/object.mjs';
import { domToUJSX } from'./dom/convert.mjs';
const w = typeof window !== 'undefined' ? window : undefined;
const auto = ujsxFor({ window: w });
const { ujsx, ujsxToDOM, ujsxToHTML } = auto;
export { isUJSXObject, createUJSXObject, ujsxFor, auto, ujsx, ujsxToDOM, ujsxToHTML, domToUJSX };
//# sourceMappingURL=ujsx.mjs.map